import * as React from 'react';
import { DateTimeInput } from '../../../components/form-elements/DateTimeInput';
import { TextInput } from '../../../components/form-elements/TextInput';
import { GlobalConstants } from '../../../utils/app-constants';
import { ShipmentActionType } from '../../models/enums/shipment-action-type';
import { ShipmentType } from '../../models/enums/shipment-type';
import { ShipmentAction, TravelShipmentAction } from '../../models/shipments/shipment-action';

interface IProps {
    item: ShipmentAction;
    entityType: ShipmentType;
    selectedStopId: number;
    idx: number;
    onClick: any;
    onShipmentTimeChange: any;
    onDistanceTimeChange: any;
    onTravelTimeChange: any;
}

export const ShipmentActionScheduleRow = (props : IProps) => {

    const getHeader = (item: ShipmentAction, idx: number) => {
        switch (item.type) {
            case ShipmentActionType.Origin:
                return <React.Fragment>
                    <span/>
                    <p>
                        { item.name }<br/>
                        { `START: ${item.address.addressLine1} ${item.address.city}, ${item.address.stateProvince} ${item.address.postalCode}` }
                    </p>
                </React.Fragment>;
            case ShipmentActionType.Destination:
                return <React.Fragment>
                    <span />
                    <p>
                        { item.name }<br/>
                        { `END: ${item.address.addressLine1} ${item.address.city}, ${item.address.stateProvince} ${item.address.postalCode}` }
                    </p>
                </React.Fragment>;
            case ShipmentActionType.Delivery:
            case ShipmentActionType.Backhaul:
                return <React.Fragment>
                    <span>{ idx + 1}</span>
                    <p>
                        { item.name }<br/>
                        { `${item.address.addressLine1} ${item.address.city}, ${item.address.stateProvince} ${item.address.postalCode}` }
                    </p>
                </React.Fragment>;
            default:
                return '';
        }
    };

   return <div className="truck-route-draggable" onClick={() => props.onClick(props.item)}>

           <div className={`stop-schedule-header ${ props.item.id === props.selectedStopId ? 'selected' : ''}`}>
               {getHeader(props.item, props.idx)}
           </div>
       
           <div className="">
               <DateTimeInput
                   id={`shipmenttime-${props.item.id}`}
                   className="compact"
                   format={GlobalConstants.ABBR_LONG_DATE}
                   value={props.item.actionTime ? props.item.actionTime.local : null}
                   showTimezone={true}
                   timezone={props.item.address.timeZoneId}
                   label=""
                   placeholder="Shipment Time"
                   onChange={(e: any) => props.onShipmentTimeChange(props.item.id, props.item.type, e)}
               />
           </div>

       {
            props.entityType === ShipmentType.Truck && props.item.type !== ShipmentActionType.Origin 
               ? <div className="delivery-schedule-info">
                   <p>DIS.</p>
                   
                   <TextInput
                       id={`distance-${props.item.id}`}
                       onChange={(e: any) => props.onDistanceTimeChange(props.item.id, props.item.type, e)}
                       value={ (props.item as TravelShipmentAction).distance }
                       label=""
                       placeholder="Distance"
                       type="number"
                   />
                   
                   <p>TRV.</p>
                   
                   <TextInput
                       id={`traveltime-${props.item.id}`}
                       onChange={(e: any) => props.onTravelTimeChange(props.item.id, props.item.type, e)}
                       value={ (props.item as TravelShipmentAction).travelTime }
                       label=""
                       placeholder="Travel Time"
                       type="text"
                   />
               </div>
               : null
       }
   </div>;
};
